import React from 'react';
import { Image, TouchableOpacity } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import {
  LightThemeColors,
  withTheme,
  getThemeImages,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import BillingTestKeys from '../../Utils/BillingTestKeys.js';
import VfView from '../VfView';

import styles from './ImageList.Styles';

function ImageList(props) {
  const { theme } = props;
  const themeImages = getThemeImages(theme?.name);
  return (
    <TouchableOpacity disabled={!props.onPress} onPress={props.onPress} activeOpacity={0.7}>
      <VfView>
        {props.showTitle && (
          <VfView style={styles.title}>
            <VFText
              testKey={BillingTestKeys.billImageListServicesDetails}
              style={styles.currentBillStyle(theme)}
              i18nKey={`${props.title}`}
            />
          </VfView>
        )}
        <VfView row justify="space-between" style={styles.imageContainer}>
          <VfView row alignItems="center">
            {props.images.map((image, i) => {
              return (
                <Image
                  key={'logoService' + i}
                  resizeMode="contain"
                  source={image}
                  style={styles.iconDimensions}
                  testID={BillingTestKeys.billImageListServicesIcon}
                />
              );
            })}
          </VfView>
          <VfView>
            <VfView justify="flex-end" alignItems="center">
              <Image
                source={themeImages.ic_chevron_right_red}
                style={styles.arrowDimensions}
                resizeMode="contain"
                testID={BillingTestKeys.billImageListServicesArrowIcon}
              />
            </VfView>
          </VfView>
        </VfView>
      </VfView>
    </TouchableOpacity>
  );
}

ImageList.defaultProps = {
  images: [],
  showTitle: true,
  theme: LightThemeColors,
};

ImageList.propTypes = {
  title: PropTypes.string,
  images: PropTypes.array,
  arrow: PropTypes.any,
  onPress: PropTypes.func,
  showTitle: PropTypes.bool,
  theme: PropTypes.object,
};

export default withTheme(ImageList);
